<template>
  <div
    id="contact"
    ref="resizeElement"
    :class="{ light: !darkMode, hasScrollBar: hasScrollBar }"
  >
    <div class="title title2" :class="{ light: !darkMode }">
      {{ $t("contact.title") }}
    </div>
    <div class="text" v-html="$t('contact.textMe')"></div>
    <form ref="form" @submit.prevent="handleSubmit">
      <div class="form-group">
        <label for="user_name">{{ $t("contact.name") }}:</label>
        <input
          type="text"
          class="text"
          name="user_name"
          id="name"
          :placeholder="$t('contact.PHname')"
          required
        />
      </div>

      <div class="form-group">
        <label for="user_email">{{ $t("contact.email") }}:</label>
        <input
          type="email"
          class="text"
          name="user_email"
          id="email"
          :placeholder="$t('contact.PHemail')"
          required
        />
      </div>

      <div class="form-group">
        <label for="message">{{ $t("contact.message") }}:</label>
        <textarea
          id="message"
          class="text"
          name="message"
          :placeholder="$t('contact.PHmessage')"
          rows="5"
          required
        ></textarea>
      </div>

      <div id="send-container" class="text">
        <button type="submit" class="submit-button">
          {{ $t("contact.send") }}
        </button>
        <div id="send-return" class="text">
          {{ sendReturn ? $t("contact." + sendReturn) : "" + error }}
        </div>
      </div>
    </form>
  </div>
  <div id="contact-list" :class="{ light: !darkMode }">
    <div
      class="contact text"
      :class="{ light: !darkMode }"
      @click="openLink('https://www.linkedin.com/in/armand-chavy/')"
    >
      LinkedIn
    </div>
    <a
      id="email-link"
      class="contact text"
      :class="{ light: !darkMode }"
      href="mailto:achavy44@gmail.com"
      >Email</a
    >
    <div
      id="resume"
      class="contact text"
      :class="{ light: !darkMode }"
      @click="openPDF"
    >
      {{ $t("home.resume") }}
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent } from "vue";
import store from "@/store";
import emailjs from "@emailjs/browser";
import axios from "axios";

export default defineComponent({
  name: "Contact",
  data(): {
    sendReturn: string;
    error: string;
    observer: ResizeObserver | null;
    hasScrollBar: boolean;
  } {
    return {
      sendReturn: "",
      error: "",
      observer: null,
      hasScrollBar: false,
    };
  },
  computed: {
    darkMode() {
      return store.state.darkMode;
    },
  },
  methods: {
    handleSubmit() {
      emailjs
        .sendForm(
          "service_kb1p8e9",
          "template_qt5tu56",
          this.$refs.form as HTMLFormElement,
          {
            publicKey: "0Krmox8E4g0Y-VIlU",
          }
        )
        .then(
          () => {
            this.sendReturn = "success";
          },
          (error) => {
            this.sendReturn = "failed";
            this.error = error.text;
          }
        );
    },
    openLink(link: string) {
      window.open(link, "_blank");
      window.URL.revokeObjectURL(link);
    },
    async openPDF() {
      let pdfPath = "/assets/CV_Armand_CHAVY_FR.pdf";
      if (this.$i18n.locale === "en") {
        pdfPath = "/assets/CV_Armand_CHAVY_EN.pdf";
      }

      const response = await axios.get(pdfPath, {
        responseType: "arraybuffer",
      });
      let pdfContent = new Uint8Array(response.data);

      const blob = new Blob([pdfContent], { type: "application/pdf" });
      const url = window.URL.createObjectURL(blob);
      window.open(url, "_blank");

      // Révoque l'URL de données après l'ouverture
      window.URL.revokeObjectURL(url);
    },
    handleResize() {
      const el = this.$refs.resizeElement as HTMLElement;
      this.hasScrollBar = el.scrollHeight > el.clientHeight;
    },
  },
  mounted() {
    const element = this.$refs.resizeElement as HTMLElement;
    if (element) {
      this.observer = new ResizeObserver(this.handleResize);
      this.observer.observe(element);
    }
  },
  beforeUnmount() {
    if (this.observer) {
      this.observer.disconnect(); // Nettoyer l'observer
    }
  },
});
</script>
<style scoped>
#contact-list {
  position: absolute;
  z-index: 100;
  left: 157px;
  top: 101px;
  border: solid 1px #ececec;
  border-radius: 5px;
  background: rgba(33, 33, 33, 0.8);
  backdrop-filter: blur(2px);
  box-shadow: 0 4px 15px rgba(33, 33, 33, 0.2);
  padding: 5px 10px;
}

#contact-list.light {
  border-color: #212121;
  background: rgba(236, 236, 236, 0.8);
  box-shadow: 0 4px 15px rgba(236, 236, 236, 0.2);
}

#resume {
  margin-top: 3px;
}

.contact {
  transition: opacity 0.3s ease;
  color: #ececec;
  text-decoration: none;
  cursor: pointer;
}

.contact.light {
  color: #212121;
}

#contact {
  position: absolute;
  z-index: 100;
  right: 20px;
  bottom: 20px;
  border: solid 1px #ececec;
  border-radius: 5px;
  background-color: rgba(33, 33, 33, 0.8);
  backdrop-filter: blur(2px);
  box-shadow: 0 4px 15px rgba(33, 33, 33, 0.2);
  padding: 6px 10px 10px 10px;
  max-height: calc(100% - 242px);
  max-width: calc(100% - 62px);
  overflow: auto;
}

#contact.hasScrollBar {
  padding-right: 2px;
  max-width: calc(100% - 54px);
}

#contact.light {
  border-color: #212121;
  background-color: rgba(236, 236, 236, 0.8);
  box-shadow: 0 4px 15px rgba(236, 236, 236, 0.2);
}

.title {
  letter-spacing: 1.5px;
  text-transform: capitalize;
  border-bottom: solid 1px #ececec;
  margin-bottom: 10px;
  padding-bottom: 5px;
}

.title.light {
  border-color: #212121;
}

.form-group {
  display: flex;
  flex-direction: column;
  margin: 5px 0px;
}

label {
  margin-bottom: 5px;
  margin-top: 10px;
}

input,
textarea {
  background: #ececec;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.submit-button {
  background-color: #ececec;
  padding: 5px 10px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  margin-top: 5px;
}

#send-container {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

#send-return {
  margin-left: 10px;
  margin-top: 5px;
  text-align: center;
}

@media (hover: hover) AND (pointer: fine) {
  .submit-button:hover {
    background-color: #0056b3;
  }

  .contact:hover {
    opacity: 0.25;
  }
}

@media screen AND (orientation: landscape) {
  #contact {
    max-height: calc(100% - 58px);
    max-width: calc(100% - 371px);
  }

  #contact.hasScrollBar {
    max-width: calc(100% - 363px);
  }
}

@media screen AND (min-width: 768px) {
  #contact {
    bottom: 30px;
    right: 30px;
    max-width: calc(100% - 101px);
    max-height: calc(100% - 347px);
    padding: 14px 20px 20px 20px;
    border-radius: 10px;
  }

  #contact.hasScrollBar {
    max-width: calc(100% - 93px);
    padding-right: 12px;
  }

  #contact-list {
    padding: 10px 15px;
    border-radius: 10px;
    top: 138px;
    left: 197px;
  }

  #email-link {
    display: inline-block;
    margin: 10px 0px;
  }

  .title {
    margin-bottom: 20px;
    padding-bottom: 10px;
  }

  #resume {
    margin-top: 0;
  }
}

@media screen AND (min-width: 768px) AND (orientation: landscape) {
  #contact {
    max-height: calc(100% - 96px);
    max-width: calc(100% - 405px);
  }

  #contact.hasScrollBar {
    max-width: calc(100% - 393px);
  }

  #contact-list {
    left: 30px;
    top: 281px;
  }
}

@media screen AND (min-width: 1200px) {
  #contact-list {
    top: 318px;
    left: 30px;
  }
}

@media screen AND (min-width: 1200px) AND (orientation: landscape) {
  #contact {
    max-width: 600px;
  }

  #contact.hasScrollBar {
    max-width: 608px;
  }

  #contact-list {
    top: 316px;
  }
}
</style>
